export default __webpack_public_path__ + "static/logo-final-0ce26c689aa6ef72e81e7e2aac1b3f84.png";